<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="addDeviceForm">
		<!-- ROW * -->
		<div class="grid">
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.selectedModel, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.selectedModel, 'label')">{{ 'MODEL' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.selectedModel, 'borderInput')">
						<p-autoComplete formControlName="selectedModel" [ngClass]="dynamicInputTextWidth()"
							[styleClass]="dynamicInputTextWidth()" inputStyleClass="pl-6 sm:pl-5 border-noround-right"
							id="add-device-dialog-input-model" placeholder="{{ 'MODEL' | translate }}"
							[suggestions]="filteredModels" [dropdown]="true" (completeMethod)="filterModels($event)"
							[forceSelection]="true" [field]="convertionModel" (onSelect)="onSelectedModel()"
							[panelStyleClass]="dynamicAutocomplete()">
						</p-autoComplete>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.selectedModel)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'INVALID_CODE' | translate }}</small>
			</div>
			<div class="col-12" *ngIf="model && model.CategoryId === 7">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.selectedPeriphNumber, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.selectedPeriphNumber, 'label')">{{ 'CRP_ADDRESS' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.selectedPeriphNumber, 'borderInput')">
						<p-dropdown [options]="periphNumbers" [ngClass]="dynamicInputTextWidth()" appendTo="body"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
							formControlName="selectedPeriphNumber" placeholder="{{ 'CRP_ADDRESS' | translate }}">
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.selectedPeriphNumber)"
					class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate
					}}</small>
			</div>
			<div class="col-12" *ngIf="model && model.CategoryId === 2">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.keyCode, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.keyCode, 'label')">{{ 'KEYCODE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.keyCode, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="inputKeyCode"
							formControlName="keyCode" autocomplete="device-name" placeholder="{{ 'KEYCODE' | translate }}" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.keyCode)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="device-add-input-name"
							formControlName="name" autocomplete="device-name" placeholder="{{ 'NAME' | translate }}"
							maxlength="48" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.description, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.description, 'label')">{{ 'DESCRIPTION' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.description, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="device-add-input-description"
							formControlName="description" autocomplete="device-inputDescription"
							placeholder="{{ 'DESCRIPTION' | translate }}" maxlength="48" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.description)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div *ngIf="multiIO()" class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.iconName, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.iconName, 'label')">{{ 'DEVICE_ICON' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.iconName, 'borderInput')">
						<p-dropdown [options]="icons" formControlName="iconName" optionValue="value"
							[ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
							id="input-add-deviceicon-multiio">
							<ng-template let-icon pTemplate="selectedItem">
								<div class="flex align-items-center justify-content-center gap-2">
									<i class="pi text-3xl cm-{{icon.value}}"></i>
								</div>
							</ng-template>
							<ng-template let-icon pTemplate="item">
								<div class="flex align-items-center justify-content-center gap-2">
									<i class="pi text-3xl cm-{{icon.value}}"></i>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.iconName)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [class]="col12Responsive()"
				*ngIf="parentInfo.AllowedInputs !== undefined && parentInfo.AllowedInputs.length > 0 && multiIO()">
				<p-panel styleClass="p-panel-whitebg">
					<ng-template pTemplate="header">
						<div class="flex align-items-center">
							<span class="font-semibold">{{ 'INPUTS' | translate }}</span>
						</div>
					</ng-template>
					<div>
						<ng-container formArrayName="inputPorts">
							<div class="flex align-items-center justify-content-around">
								<p-checkbox *ngFor="let input of parentInfo.AllowedInputs; let i=index;" [formControlName]="i"
									[binary]="true" label="{{ input }}" [class]="showErrorRequiredCheckBox(this.f.inputPorts)"
									class="ml-4 mb-2 md:mb-0">
								</p-checkbox>
							</div>
						</ng-container>
					</div>
				</p-panel>
				<small *ngIf="showErrorRequiredMessage(this.f.inputPorts)"
					class="flex align-items-center text-50 pt-1 justify-content-center text-center">{{ 'REQUIRED' | translate
					}}</small>
			</div>
			<div [class]="col12Responsive()"
				*ngIf="parentInfo.AllowedOutputs !== undefined && parentInfo.AllowedOutputs.length > 0 && multiIO()">
				<p-panel styleClass="p-panel-whitebg">
					<ng-template pTemplate="header">
						<div class="flex align-items-center">
							<span class="font-semibold">{{ 'OUTPUTS' | translate }}</span>
						</div>
					</ng-template>
					<div>
						<ng-container formArrayName="outputPorts">
							<div class="flex align-items-center justify-content-around">
								<p-checkbox *ngFor="let output of parentInfo.AllowedOutputs; let i=index;" [formControlName]="i"
									[binary]="true" label="{{ output }}" [class]="showErrorRequiredCheckBox(this.f.outputPorts)"
									class="ml-4 mb-2 md:mb-0">
								</p-checkbox>
							</div>
						</ng-container>
					</div>
				</p-panel>
				<small *ngIf="showErrorRequiredMessage(this.f.outputPorts)"
					class="flex align-items-center text-50 pt-1 justify-content-center text-center">{{ 'REQUIRED' | translate
					}}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>